<template>
  <main>
    <small
      class="cursor-pointer text-primary"
      v-if="!isMarketAdmin"
      @click="showPopup = true"
    >
      Mint NFT/Tokens
    </small>
    <div
      class="cursor-pointer flex justify-between items-center gap-x-1"
      v-else
      @click="showPopup = true"
    >
      <input
        class="border-gray"
        type="checkbox"
        :checked="
          orgProductMintableContractDetails.contractAddress != '' &&
          orgProductMintableContractDetails.mintFunctionABI.length > 0
        "
        @click="preventToggle"
      />
      <p class="text-sm coupons-text">Mintable</p>
    </div>
    <vs-popup
      :title="
        [this.isMarketAdmin ? 'Mint NFT/Tokens' : 'Mint ' + this.productType][0]
      "
      :active.sync="showPopup"
    >
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-3">
          <div
            v-if="isMarketAdmin"
            class="btn-container flex justify-between items-center"
          >
            <button
              :class="[
                (this.contractType === '0' ? 'treasury-btn-2 ' : 'ml-5 pr-1 ') +
                  'border-none',
              ]"
              @click="contractType = '0'"
            >
              NFTs
            </button>
            <button
              :class="[
                (this.contractType === '1' ? 'treasury-btn-2 ' : '') +
                  'ml-5 pr-1 border-none',
              ]"
              @click="contractType = '1'"
            >
              Token
            </button>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-3">
          <p class="label mb-1">
            Select a Network <span class="required">*</span>
          </p>
          <vs-select
            placeholder="Select network"
            class="w-full"
            :disabled="!isMarketAdmin"
            v-model="selectedNetwork"
          >
            <vs-select-item
              :key="index"
              :value="item"
              :text="item.text"
              v-for="(item, index) in options"
            />
          </vs-select>
        </div>
        <div class="vx-col w-1/2 mb-3">
          <p class="label mb-1">
            Contract Address <span class="required">*</span>
          </p>
          <input
            type="text"
            placeholder="Ex: 0xE51092Ee46eF341b683b7Ed517449e8e0c864Cec"
            :class="[
              (!isMarketAdmin ? 'input-disabled' : '') +
                ' w-full p-4 all-inputs',
            ]"
            :disabled="!isMarketAdmin"
            v-model="contractAddress"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-3">
          <p class="label mb-1">ABI <span class="required">*</span></p>
          <vs-textarea
            :class="[!isMarketAdmin ? 'input-disabled' : '']"
            label="You can put your text here"
            height="90px"
            :disabled="!isMarketAdmin"
            v-model="mintFunctionABI"
          />
        </div>
      </div>
      <div class="vx-col mb-3" v-if="!isMarketAdmin && walletAddress !== ''">
        <p class="label mb-1">Wallet Address</p>
        <div class="flex gap-x-2 items-center">
          <input
            type="text"
            placeholder="Ex: 0xE51092Ee46eF341b683b7Ed517449e8e0c864Cec"
            :class="['input-disabled w-full p-4 all-inputs']"
            :disabled="!isMarketAdmin"
            v-model="walletAddress"
          />
          <img
            class="cursor-pointer"
            src="@/assets/Iconography/market/CopyIcon.svg"
            alt="Market Icon"
            height="20px"
            width="20px"
            @click="copyAddress()"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/3 mb-3">
          <p class="label mb-1">Parameters</p>
          <input
            placeholder='Ex: {"count":"1"}'
            type="text"
            class="w-full p-4 all-inputs"
            v-model="mintFunctionParameters"
          />
        </div>
        <div class="vx-col w-1/3 mb-3">
          <p class="label mb-1">
            Mint Function Name <span class="required">*</span>
          </p>
          <input
            placeholder="Ex: mintNFTs"
            type="text"
            :class="[
              (!isMarketAdmin ? 'input-disabled' : '') +
                ' w-full p-4 all-inputs',
            ]"
            v-model="mintFunctionName"
            :disabled="!isMarketAdmin"
          />
        </div>
        <div class="vx-col w-1/3 mb-3">
          <p class="label mb-1">Price</p>
          <input
            placeholder="Ex: 0.0009(ETH)"
            type="text"
            class="w-full p-4 all-inputs"
            v-model="mintPriceETH"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-3">
          <vs-button
            class="text-white bottom-btn border-none p-3"
            v-if="!isMarketAdmin"
            @click="mintToken"
          >
            Mint NFT
          </vs-button>
          <vs-button
            class="text-white bottom-btn border-none p-3"
            v-else
            @click="saveContractDetails"
          >
            Save Contract Details
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </main>
</template>

<script>
import { ethers } from "ethers";
export default {
  components: {},
  props: {
    orgId: String,
    logId: String,
    fetchTransactions: Function,
    isMarketAdmin: Boolean,
    productType: String,
    loggedContractDetails: Object,
    walletAddress: String,
  },
  computed: {
    orgProductMintableContractDetails() {
      return this.$store.state.market.orgProductMintableContractDetails;
    },
  },
  data() {
    return {
      showPopup: false,
      contractType: "0",
      contractTypeDetailsExist: false,
      selectedNetwork: {},
      contractAddress: "",
      mintFunctionABI: "",
      mintFunctionName: "",
      mintFunctionParameters: "",
      mintPriceETH: "",
      fetchedContractDetails: [],
      options: [
        {
          text: "Ethereum",
          value: 1,
          chainIdHex: "0x1",
          chainId: 1,
          currency: "ETH",
        },
        {
          text: "Mumbai",
          value: 80001,
          chainIdHex: "0x13881",
          chainId: 80001,
          currency: "MATIC",
        },
      ],
    };
  },
  async mounted() {
    if (!this.isMarketAdmin) {
      this.fetchContractDetails(this.loggedContractDetails);
    }
  },
  watch: {
    loggedContractDetails: {
      handler(newVal, oldVal) {
        if (
          newVal.contractAddress.length > 0 &&
          newVal.mintFunctionABI.length > 0
        ) {
          this.fetchContractDetails(newVal);
        }
      },
    },
  },
  methods: {
    preventToggle(e) {
      e.preventDefault();
    },
    copyAddress() {
      navigator.clipboard.writeText(this.walletAddress);
      this.$vs.notify({
        title: "Copied",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
    },
    reset() {
      this.contractType = "NFT";
      this.contractTypeDetailsExist = false;
      this.selectedNetwork = this.options[0];
      this.contractAddress = "";
      this.mintFunctionABI = "";
      this.mintFunctionName = "";
      this.mintFunctionParameters = "";
      this.mintPriceETH = "";
    },
    fetchContractDetails(newVal) {
      // console.log("Fetched contract details:", newVal);
      this.contractType = newVal.contractType;
      this.contractTypeDetailsExist = true;
      this.selectedNetwork = this.options.filter(
        (option) => option.text === newVal.network.text
      )[0];
      this.contractAddress = newVal.contractAddress;
      this.mintFunctionABI = newVal.mintFunctionABI;
      this.mintFunctionName = newVal.mintFunctionName;
      this.mintFunctionParameters = newVal.mintFunctionParameters;
      this.mintPriceETH = newVal.mintPriceETH;
    },
    async verifyChain() {
      const selectedChain = await window.ethereum.request({
        method: "eth_chainId",
      });
      if (selectedChain.toString() !== this.selectedNetwork.chainIdHex) {
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: this.selectedNetwork.chainIdHex }],
          });
        } catch (error) {
          this.$vs.notify({
            title: "Error In Switching Chain",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          // console.log("Switching chain error", error);
          // Not allowing to add network coz it will require rpc url which will be ours
          // if acceptable we can add network from here also
        }
      }
    },
    async connectMetamask() {
      await window.ethereum.request({ method: "eth_requestAccounts" });
      this.verifyChain();
    },
    async mintToken() {
      if (window.ethereum !== undefined) {
        await this.connectMetamask();

        this.$vs.loading();

        // get signer
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        // create contract instance
        const contract = new ethers.Contract(
          this.contractAddress,
          JSON.parse(this.mintFunctionABI),
          signer
        );

        // get mint function name and parameters
        const mintFunctionName = this.mintFunctionName;
        let mintFunctionParameters;
        let mintPriceETH = ethers.utils.parseEther(this.mintPriceETH || "0");

        if (this.mintFunctionParameters === "") {
          mintFunctionParameters = [];
        } else {
          mintFunctionParameters = JSON.parse(this.mintFunctionParameters);
        }

        const transactionOptions = {
          value: mintPriceETH,
          gasLimit: 3000000, // Increase gas limit
        };

        // create transaction amd mint token
        const tx = await contract[mintFunctionName](
          ...Object.values(mintFunctionParameters),
          transactionOptions
        );

        // wait for transaction to be mined
        tx.wait(1)
          .then(async () => {
            // Create Payload for the api
            const payload = {
              orgId: this.orgId,
              userId: JSON.parse(localStorage.getItem("user"))._id,
              accessToken: localStorage.getItem("accessToken"),
              logId: this.logId,
            };

            this.$store
              .dispatch("market/acceptTokenMinted", payload)
              .then(() => {
                this.$vs.notify({
                  title: this.contractType + " Minted",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                });
                this.$vs.loading.close();
                this.fetchTransactions();
                this.showPopup = false;
              })
              .catch((err) => {
                console.log(err);
                this.$vs.notify({
                  title: "Internal Server Error",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                });
              });
          })
          .catch((error) => {
            console.log("error", error);
            this.$vs.notify({
              title: "Transaction Failed",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          });
      }
    },
    saveContractDetails() {
      const contractDetails = {
        contractType: this.contractType,
        network: this.selectedNetwork,
        contractAddress: this.contractAddress,
        mintFunctionABI: this.mintFunctionABI,
        mintFunctionName: this.mintFunctionName,
        mintFunctionParameters: this.mintFunctionParameters.toString(),
        mintPriceETH: this.mintPriceETH,
      };
      this.$store.commit(
        "market/ORG_PRODUCT_MINTABLE_CONTRACT_DETAILS",
        contractDetails
      );
      this.showPopup = false;
    },
  },
};
</script>

<style scoped>
.input-disabled {
  background: #f1f1f1;
  color: #a8a3a3;
}
.treasury-btn {
  border: 2px solid black;
  border-radius: 20px !important;
  background: inherit;
  padding: 7px 14px;
  font-weight: bolder;
}
.treasury-btn:hover {
  background: black;
  color: aliceblue;
}
.btn-container {
  padding: 3px 5px;
  background: #f1f1f1;
  border-radius: 20px;
  width: fit-content;
}
.treasury-btn-2 {
  background: #6859b4;
  padding: 3px 14px;
  color: white;
}
.required {
  color: red;
}
.all-inputs {
  height: 2.5rem;
  border: 1px solid #a8a3a3;
  border-radius: 4px;
}
.bottom-btn {
  background: #6859b4;
  border-radius: 6px !important;
}
</style>
<!-- 0x4820423DA1b851B9248Dcc33797C1F95698EA15E nft contract address to test -->
<!-- [{
		"inputs": [
			{
				"internalType": "address",
				"name": "_to",
				"type": "address"
			}
		],
		"name": "mint",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}]
ABI to test -->
